import { useLocation, Outlet } from 'react-router';
import {
    LayoutGrid01,
    Package,
    Users01,
    UserPlus01,
    BookOpen01,
    Settings01,
    HelpCircle,
    Clock,
    ShoppingCart01,
    FileCheck02,
    File01
} from '@untitledui/icons';
import { SidebarNavigationSimple } from '@/components/application/app-navigation/sidebar-navigation/sidebar-simple';
import { AICTACard } from '@/components/application/ai-chat/ai-cta-card';
import { HeaderNavigationBase } from '@/components/application/app-navigation/header-navigation';
import type { NavItemType } from '@/components/application/app-navigation/config';
import { useTranslation } from 'react-i18next';

export const ShipperLayout = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation('navigation');

    // Navigation items for sidebar
    const sidebarItems: NavItemType[] = [
        {
            label: t('dashboard'),
            href: '/shipper/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('orders'),
            href: '/shipper/orders',
            icon: ShoppingCart01
        },
        {
            label: t('quotes'),
            href: '/shipper/quotes',
            icon: FileCheck02
        },
        {
            label: t('containers'),
            href: '/shipper/containers',
            icon: Package
        },
        {
            label: t('documents'),
            href: '/shipper/documents',
            icon: File01
        },
        {
            label: t('activity'),
            href: '/shipper/activity',
            icon: Clock
        },

        {
            label: t('receivers'),
            href: '/shipper/receivers',
            icon: Users01
        },
        {
            label: t('team'),
            href: '/shipper/team',
            icon: UserPlus01
        },
        {
            label: t('addressBook'),
            href: '/shipper/address-book',
            icon: BookOpen01
        },
        {
            label: t('settings'),
            href: '/shipper/settings',
            icon: Settings01
        }
    ];

    // Header navigation items
    const headerItems = [
        {
            label: t('dashboard'),
            href: '/shipper/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('containers'),
            href: '/shipper/containers',
            icon: Package
        },
        {
            label: t('documents'),
            href: '/shipper/documents',
            icon: File01
        },
        {
            label: t('activity'),
            href: '/shipper/activity',
            icon: Clock
        },
        {
            label: t('quotes'),
            href: '/shipper/quotes',
            icon: FileCheck02
        },
        {
            label: t('orders'),
            href: '/shipper/orders',
            icon: ShoppingCart01
        },
        {
            label: t('receivers'),
            href: '/shipper/receivers',
            icon: Users01
        },
        {
            label: t('team'),
            href: '/shipper/team',
            icon: UserPlus01
        },
        {
            label: t('addressBook'),
            href: '/shipper/address-book',
            icon: BookOpen01
        },
        {
            label: t('settings'),
            href: '/shipper/settings',
            icon: Settings01
        }
    ];

    // Footer items for sidebar
    const footerItems: NavItemType[] = [
        {
            label: t('support'),
            href: '#',
            icon: HelpCircle
        },
    ];

    const env = import.meta.env.VITE_ENV;
    const hasEnvironmentBanner = env !== "production";

    return (
        <div className={`flex h-screen bg-secondary ${hasEnvironmentBanner ? "pt-7" : ""}`}>
            {/* Sidebar Navigation */}
            <SidebarNavigationSimple
                activeUrl={currentPath}
                items={sidebarItems}
                footerItems={footerItems}
                featureCard={<AICTACard />}
                showAccountCard={true}
                className="hidden lg:flex"
            />

            {/* Main Content */}
            <div className="flex flex-1 flex-col overflow-hidden">
                {/* Header Navigation */}
                <HeaderNavigationBase
                    activeUrl={currentPath}
                    items={headerItems}
                    showAvatarDropdown={true}
                />

                {/* Page Content */}
                <main className="flex-1 overflow-auto bg-secondary">
                    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};
